import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Container from '@/components/base/Container';
import PageHeader from '@/components/base/PageHeader';
import Reveal from '@/components/base/Reveal';
import PartnerPortrait from '@/components/feature/PartnerPortrait';
import { partners } from '@/mocks/site';

export default function PeoplePage() {
  return (
    <SiteLayout title="People | AVENOR Accounting & Advisory">
      <PageHeader
        index="04"
        label="People"
        title="Experience behind every decision."
        intro="Four partners, each leading a practice area and each personally responsible for the clients they advise."
        letter="P"
      />

      <section className="paper-texture border-t border-background-200 bg-background-100 py-16 md:py-24">
        <Container>
          <div className="grid grid-cols-2 gap-x-4 gap-y-10 md:gap-x-6 lg:grid-cols-4">
            {partners.map((p, i) => (
              <Reveal key={p.slug} delay={i * 80}>
                <a href={`#${p.slug}`} className="group block cursor-pointer">
                  <PartnerPortrait partner={p} variant={i} />
                  <p className="mt-4 text-base text-foreground-950 group-hover:text-primary-500 md:text-lg">{p.name}</p>
                  <p className="font-label text-[10px] uppercase tracking-[0.12em] text-foreground-600 md:text-[11px]">{p.role}</p>
                </a>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      {partners.map((p, i) => (
        <section key={p.slug} id={p.slug} className={`scroll-mt-24 border-t border-background-200 py-16 md:py-24 ${i % 2 ? 'bg-background-100' : 'bg-background-50'}`}>
          <Container>
            <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-6">
              <Reveal className="md:col-span-5 lg:col-span-4">
                <PartnerPortrait partner={p} variant={i} />
              </Reveal>
              <Reveal delay={120} className="md:col-span-7 lg:col-span-6 lg:col-start-6">
                <p className="font-label text-[11px] uppercase tracking-[0.14em] text-primary-500">0{i + 1} / {p.focus}</p>
                <h2 className="mt-5 font-heading text-4xl font-light leading-[1.05] tracking-[-0.02em] md:text-5xl">{p.name}</h2>
                <p className="mt-3 text-base text-foreground-700">{p.role}</p>
                <div className="mt-8 space-y-5 border-t border-background-200 pt-8">
                  {p.bio.map((para) => (
                    <p key={para.slice(0, 24)} className="text-[15px] leading-[1.7] text-foreground-800 md:text-base">{para}</p>
                  ))}
                </div>
                <Link to="/contact" className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:text-primary-500">
                  <i className="ri-arrow-right-line" /> <span className="ed-link">Arrange a conversation</span>
                </Link>
              </Reveal>
            </div>
          </Container>
        </section>
      ))}
    </SiteLayout>
  );
}